var gradientActive;
var gradientIdle;
var gradientLocked;
var base = document.getElementsByTagName('base')[0].href;

jQuery.expr[':'].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};

$(function () {

    // Create the gradients for charts
    var chartCanvas = $('<canvas width="400" height="300"></canvas>')[0].getContext('2d');

    // Citytalk Blue
    gradientActive = chartCanvas.createLinearGradient(0, 0, 0, 350);
    gradientActive.addColorStop(0, '#2544b7');
    gradientActive.addColorStop(1, '#66d8b0');

    // Citytalk Energy Orange
    gradientIdle = chartCanvas.createLinearGradient(0, 0, 0, 350);
    gradientIdle.addColorStop(0, '#fac556');
    gradientIdle.addColorStop(1, '#f4932b');

    // Citytalk V&D Purple
    gradientLocked = chartCanvas.createLinearGradient(0, 0, 0, 350);
    gradientLocked.addColorStop(0, '#c93ea1');
    gradientLocked.addColorStop(1, '#981d68');

    // Citytalk IT Green
    gradientMeeting = chartCanvas.createLinearGradient(0, 0, 0, 350);
    gradientMeeting.addColorStop(0, '#66d8af');
    gradientMeeting.addColorStop(1, '#36b078');

    setLoadingIndicators();

    $('[data-toggle="tooltip"]').tooltip();
    
});


function setLoadingIndicators() {

    $(document).on('click', ':submit:not(.noloading), .showloading, .showLoading', function () {
        $(this).find('i').data('originalclass', $(this).find('i').attr('class')).attr('class', 'icon-Refresh spin');
        if ($(this).find('i').length === 0) {
            $(this).data('originalhtml', $(this).html());
            $(this).append('<i class="icon-Refresh spin"></i>');
        }
    });
    $(document).ajaxComplete(function () {
        $(':submit i, .showloading i, .showLoading i').not('.keepLoading i').each(function () {
            var originalClass = $(this).data('originalclass');
            var originalHtml = $(this).parent().data('originalhtml');
            if (originalClass !== undefined) {
                $(this).attr('class', originalClass);
            } else if (originalHtml !== undefined) {
                $(this).parent().html(originalHtml);
            }
        });
    });

    $('form').addTriggersToJqueryValidate().triggerElementValidationsOnFormValidation();


    $('form').formValidation(function (element, result) {
        if (!result) {
            $(':submit i, .showloading i, .showLoading i').each(function () {
                var originalClass = $(this).data('originalclass');
                var originalHtml = $(this).parent().data('originalhtml');
                if (originalClass !== undefined) {
                    $(this).attr('class', originalClass);
                } else if (originalHtml !== undefined) {
                    $(this).parent().html(originalHtml);
                }
            });
        }
    });

}

function startLoadingIndicator(target) {
    target.find('i').data('originalclass', $(this).find('i').attr('class')).attr('class', 'icon-Refresh spin');
    if (target.find('i').length === 0) {
        target.data('originalhtml', $(this).html());
        target.append('<i class="icon-Refresh spin"></i>');
    }
}

function endLoadingIndicator(target) {
    var originalClass = target.find('i').data('originalclass');
    var originalHtml = target.parent().data('originalhtml');

    if (originalClass !== undefined) {
        target.find('i').attr('class', originalClass);
    } else if (originalHtml !== undefined) {
        target.html(originalHtml);
    }
}



$(function () {

    var from = moment($('.fromDate').data('currentdate'));


    if (typeof page === 'undefined' || page === null || page != 'overview') return;

    var refreshId = 0;
    if (location.hostname != 'localhost') {
        refreshId = setInterval(function () {
            $('.refresh').trigger('click');
        }, 30000);
    }
    initDatePickerOverview();


    $(document).on('click', '.previousDay', function (e) {
        e.preventDefault();
        from = from.add(-1, 'days');
        getOverviewData(from.format());
    });

    $(document).on('click', '.nextDay', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('disabled')) { 
            from = from.add(1, 'days');
            getOverviewData(from.format());
        }
    });

    $(document).on('click', '.refresh', function (e) {
        e.preventDefault();
        getOverviewData(from.format());
    });

    $(document).on('keyup', '#userSearch', function (e) {
        e.preventDefault();
        var searchValue = $('#userSearch').val();
        $('#overviewContainer .card').hide();
        $('#overviewContainer .card .overviewItemHeader:contains(' + searchValue + ')').parents('.card').show();

    });

    $(document).on('change', '#currentUser_ClientId', function (e) {
        startLoadingIndicator($('.refresh'));
        $.post({
            url: base + "Admin/SetCurrentUserClient",
            data: {
                clientId: $('#currentUser_ClientId').val()
            },
            success: function () {
                window.location.reload();
            }
        });
    });

    //renderPies();

    $(document).on('click', '.moveEmployeeRight', function (e) {
        var button = $(this);
        var card = $(this).parents('.overviewItem');
        var nextCard = card.next();
        e.preventDefault();

        $.post({
            url: base + "Employees/Move",
            data: {
                direction: 'right',
                id: card.data('employeeid')
            },
            success: function () {
                endLoadingIndicator(button);
                card.remove();
                nextCard.after(card);
            }
        });
    });
    $(document).on('click', '.moveEmployeeLeft', function (e) {
        var button = $(this);
        var card = $(this).parents('.overviewItem');
        var nextCard = card.prev();
        e.preventDefault();

        $.post({
            url: base + "Employees/Move",
            data: {
                direction: 'left',
                id: card.data('employeeid')
            },
            success: function () {
                endLoadingIndicator(button);
                card.remove();
                nextCard.before(card);
            }
        });
    });
    $(document).on('click', '.hideEmployee', function (e) {
        var button = $(this);
        var card = $(this).parents('.overviewItem');
        var nextCard = card.prev();
        e.preventDefault();

        $.post({
            url: base + "Employees/Hide",
            data: {
                id: card.data('employeeid')
            },
            success: function () {
                card.fadeOut(function () {
                    card.remove();
                });
            }
        });
    });

    //getEmailCounts(from.format());

    getOverviewCards(from.format());

});

function getEmailCounts(startDate) {
    $('.overviewItem').each(function () {
        // See if we need to fetch outgoing email count
        if ($(this).find('.loadingEmails').length < 1) return;

        var card = $(this);

        $.get({
            url: base + "EmployeeDetails/GetOutgoingEmailCount",
            data: {
                employeeId: card.data('id'),
                startDate: startDate
            },
            success: function (d) {
                card.find('.loadingEmails').replaceWith(d);
            }
        });

    });
}

function initDatePickerOverview() {

    $("#chooseDate").datetimepicker('destroy');

    $(document).on('click', '#chooseDate', function (e) {
        e.preventDefault();
        $("#chooseDate").datetimepicker({
            format: 'L',
            icons: {
                previous: 'greyIcons icon-chevron chevronLeft',
                next: 'greyIcons icon-chevron chevronRight'
            },
            date: moment($('.fromDate').data('currentdate')),
            maxDate: moment()
        });
        $('#chooseDate').datetimepicker('toggle');
        $("#chooseDate").on("change.datetimepicker", ({ date, oldDate }) => {
            if (oldDate != undefined) {
                getOverviewData(date.format());               
            }
        });
    });
   

}

function getOverviewData(date) {

    startLoadingIndicator($('.refresh'));

    $('.fromDate').html(moment(date).format('dddd Do MMMM yyyy'));
    if (moment(date).isSame(moment(), "day")) {
        $('.nextDay').css('opacity', 0.4).css('cursor', 'default').addClass('disabled');
    }
    else {
        $('.nextDay').css('opacity', 1).css('cursor', 'pointer').removeClass('disabled');
    }

    $('.overviewItem').addClass('outdated').find('.outdated').html('<i class="icon-Refresh spin"></i>');

    getOverviewCards(date);

    //$.get(base + "home/overview", { Day: date }, function (data) {
    //    pieCharts = [];

    //    $('#overviewContainer').html(data);
    //    renderPies();
    //    getEmailCounts(date);
    //    endLoadingIndicator($('#chooseDate'));
    //});
}

function getOverviewCards(date) {

    var cardsToFetch = $('.overviewItem:not(.unlicenced)').length;
    $('.overviewItem:not(.unlicenced)').each(function () {
        var thisCard = $(this);
        
        $.get(base + "home/employeeCard", { Day: date, Employee: $(this).data('employeeid') }, function (data) {
            var newCard = $(data).replaceAll(thisCard);
            var pieId = newCard.find('.idleChart').data('id');
            if (pieId != undefined) {
                renderPie(pieId);
            }
            newCard.find('[data-toggle="tooltip"]').tooltip();
            cardsToFetch--;
        });
    });


    var cardLoop = setInterval(function() {

        console.log("Cards to fetch", cardsToFetch);
        if (cardsToFetch > 0) {
            return;
        }
        $('body').addClass('PageFinished');
        $('.refresh i').removeClass('spin');  
        clearInterval(cardLoop);

    }, 500);

   
}


function renderPie(i) {

    var thisChart = $('#idleChart' + i).html('<canvas width="170" height="170"></canvas>').find('canvas')[0].getContext('2d');

    window['IdleData' + i].datasets[0].backgroundColor[0] = gradientActive;
    window['IdleData' + i].datasets[0].backgroundColor[1] = gradientIdle;
    window['IdleData' + i].datasets[0].backgroundColor[2] = gradientMeeting;
    window['IdleData' + i].datasets[0].backgroundColor[3] = gradientLocked;

    var legendColors = ['linear-gradient(to right, #1299ce, #66d8af)',
        'linear-gradient(to right, #fac556, #f4932b)',
        'linear-gradient(to right, #66d8af, #36b078)',
        'linear-gradient(to right, #c93ea1, #981d68)'];

    var thisPieChart = new Chart(thisChart, {
        type: 'pie',
        data: window['IdleData' + i],
        options: {
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {

                        let label = data.labels[tooltipItem.index];
                        let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return ' ' + label + ': ' + value;

                    }
                }
            },
            legendCallback: function (chart) {

                var text = [];
                text.push('<div class="pieLegend">');
                for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
                    if (chart.data.datasets[0].data[i] == 0) {
                        continue;
                    }
                    text.push('<div>');
                    text.push('<span class="legendLabel" style="background:' + legendColors[i] + '">' + '</span>');
                    if (chart.data.labels[i]) {
                        text.push(chart.data.labels[i]);
                    }
                    text.push(' - ' + chart.data.datasets[0].data[i] + '%');
                    text.push('</div>');
                }
                text.push('</ul>');
                return text.join("");
            },
            legend: {
                display: false
            }
        }
    });

    $('#idleChartLegend' + i).html(thisPieChart.generateLegend());
}

function renderPies() {
    for (i = 0; i < pieCharts.length; i++) {

        var pieId = pieCharts[i];

        renderPie(pieId);
    }
}

$(function () {

    if (typeof page === 'undefined' || page === null ||  page != 'EmployeeDetails') return;
 
    renderPies();
    initDatePickerDetails();
});


function initDatePickerDetails() {

    $("#chooseDate").datetimepicker('destroy');

    var format = 'L';
    switch (period) {
        case 'monthly':
            format = 'M';
            break;
    }

    $(document).on('click', '#chooseDate', function (e) {
        e.preventDefault();
        $("#chooseDate").datetimepicker({
            format: format,
            icons: {
                previous: 'greyIcons icon-chevron chevronLeft',
                next: 'greyIcons icon-chevron chevronRight'
            },
            date: moment($('#dateInput').val()),
            maxDate: moment()
        });
        $('#chooseDate').datetimepicker('toggle');
        $("#chooseDate").on("change.datetimepicker", ({ date, oldDate }) => {
            if (oldDate != undefined) {
                window.location = '/EmployeeDetails/Overview/' + user + '?targetDate=' + date.format('yyyy-MM-DD') + '&period=' + period;
            }
        });
    });


}